import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchQuotesStats, type QuoteStatsData } from '../apis/fetchQuotesStats';
import type { ApiResponse } from '../../../types/apiResponse';
import withPrefix from '../../../helpers/useQueryPrefix';

export const useFetchQuotesStats = (): UseQueryResult<QuoteStatsData[], Error> => {
  return useQuery<ApiResponse<QuoteStatsData[]>, Error, QuoteStatsData[]>({
    queryKey: withPrefix(['quotes-stats']),
    queryFn: fetchQuotesStats,
    select: (response) => {
      if (response.status !== 200) {
        throw new Error(response.message);
      }
      return response.data as QuoteStatsData[];
    },
  });
};
